import { defineStore } from 'pinia'

export const useScheduleStore = defineStore('schedule', {
    state: () => ({
        generating: false,
        progressStep: '',
        progressPercent: 0,
        currentExamId: null
    }),
    actions: {
        startGenerating(examId) {
            this.generating = true
            this.currentExamId = examId
            this.progressStep = '准备排程...'
            this.progressPercent = 0
        },
        updateProgress(step, percent) {
            this.progressStep = step
            this.progressPercent = percent
        },
        finishGenerating() {
            this.generating = false
            this.progressStep = '排程完成'
            this.progressPercent = 100
            // Keep examId for a moment if needed, then clear
            setTimeout(() => {
                if (!this.generating) {
                    this.currentExamId = null
                }
            }, 5000)
        },
        reset() {
            this.generating = false
            this.progressStep = ''
            this.progressPercent = 0
            this.currentExamId = null
        }
    }
})
